import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/only-export-components */
import { createContext, useContext } from 'react';
const PortalContainerContext = createContext(null);
export function PortalContainerProvider({ children, container, }) {
    return (_jsx(PortalContainerContext.Provider, { value: container, children: children }));
}
export function usePortalContainer() {
    return useContext(PortalContainerContext);
}
